import { render, staticRenderFns } from "./ui-upload.vue?vue&type=template&id=aa2d25b8&scoped=true"
import script from "./ui-upload.vue?vue&type=script&lang=js"
export * from "./ui-upload.vue?vue&type=script&lang=js"
import style0 from "./ui-upload.vue?vue&type=style&index=0&id=aa2d25b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d25b8",
  null
  
)

export default component.exports